<div appModal #modal="modal">
    <div class="modal-dialog modal-dialog-centered" role="document">

        <div class="modal-content">
          <div class="modal-header text-center">
            <h5 class="modal-title" >Free Trial</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
    
          <div class="modal-body text-center" >
            <h4>Free Trial</h4>
    
          </div>
        </div>
    
      </div>
</div> 